// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3yCix","checkboxCol":"Table_checkboxCol__2ZdvB","emailCol":"Table_emailCol__3RZBf","actionCol":"Table_actionCol__30-Iu"};